export enum BetContent {
    SitInBet,
    SitInSurrender,
    SitInSplit,
    SitInDoubleDown,
    SitInPair,
    Insurance,

    BetBehind,
    BetBehindSurrender,
    BetBehindSplit,
    BetBehindDoubleDown,
    BetBehindPair,

    SitInDoubleDownH1, //BJ2
    SitInDoubleDownH2, //BJ2
    BetBehindDoubleDownH1, //BJ2
    BetBehindDoubleDownH2, //BJ2
    BetBehindInsurance,
}
